export default "__VITE_ASSET__9eJvqjYs__"